// initial state
const state = {
  filters: {},
  showExportDialog: false
}

// mutations
const mutations = {
  // export dialog
  SHOW_EXPORT_DIALOG(state) {
    state.showExportDialog = true;
  },

  HIDE_EXPORT_DIALOG(state) {
    state.showExportDialog = false;
  },

  SET_FILTERS(state, filters) {
    for (const key in filters) {
      if (filters[key] == '') {
        filters[key] = undefined;
      }
    }
    state.filters = filters;
  }
}

// actions
const actions = {}

export default {
  namespaced: true,
  name: 'statistics',
  state,
  actions,
  mutations
}
